<template>
  <div style="padding: 0 20px">
    <a-row :gutter="24" class="row-box" style="margin-top: 20px">
      <template v-for="(item, index) in stuCardList">
        <a-col :span="24" class="flex-between title-margin">
          <!--<div class="title-1">{{ item.title }}</div>-->
          <div>
            <a-radio-group
              v-if="index == 0"
              v-model="modeType"
              @change="changModeType"
              style="margin-left: auto"
            >
              <a-radio-button value="1">工作预览</a-radio-button>
              <a-radio-button value="2">整体数据概览</a-radio-button>
            </a-radio-group>
          </div>
          <div>
            <j-dict-select-tag
              style="width: 160px"
              v-model="queryParam.schoolYear"
              placeholder="请选择学年"
              dictCode="academic_year_scope"
              :isShowEmpty="false"
              @select="selectSchoolYear"
            />
          </div>
        </a-col>
        <a-col
          v-for="(sItem, sIndex) in item.list"
          :key="sIndex"
          :span="6"
          style="margin-bottom: 20px"
        >
          <a-card class="key-point-item" :style="{ backgroundColor: sItem.backgroundColor }">
            <div class="title-1" :style="{ color: '#fff' }">
              {{ sItem.label }}
            </div>
            <div :style="{ marginTop: '20px', color: '#fff' }">
              <span class="number-value">
                <CountAnimation :end-val="sItem.value" />
              </span>
              {{ sIndex > 0 ? '次' : '人' }}
            </div>
          </a-card>
        </a-col>
      </template>
      <!--<template v-for="item in stuOverviewList">-->
      <!--  <a-col :span="24" class="title-1 title-margin">{{ item.title }}</a-col>-->
      <!--  <a-col-->
      <!--    :span="24"-->
      <!--    style="border: 1px solid #e8e8e8; border-radius: 10px; padding: 20px; margin-bottom: 20px"-->
      <!--  >-->
      <!--    <a-col v-for="(lItem, lIndex) in item.list" :key="lIndex" :span="3" class="plan-card">-->
      <!--      <div class="number-value" style="padding-top: 30px; color: #333333">-->
      <!--        <CountAnimation :end-val="lItem.value" />-->
      <!--      </div>-->
      <!--      <div style="padding: 15px 0 20px; font-size: 16px">{{ lItem.label }}</div>-->
      <!--    </a-col>-->
      <!--  </a-col>-->
      <!--</template>-->
    </a-row>
  </div>
</template>

<script>
import CountAnimation from '@/components/CountAnimation'
import { getAction } from '@api/manage'
import { getYearStarting } from '@/utils/util'

export default {
  name: 'OverallDataOverview',
  components: {
    CountAnimation,
  },
  props: {
    modeType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      queryParam: {},
      loading: true,
      schoolYear: [],
      // 重点关爱学生/小叮当提醒学生
      stuCardList: [
        {
          title: '全校·整体数据概览',
          list: [
            {
              value: 60,
              key: 'careListCnt',
              label: '总重点关爱学生数',
              backgroundColor: '#F66860',
            },
            {
              value: 0,
              key: 'txCnt',
              label: '总提醒次数',
              backgroundColor: '#1783E8',
            },
            {
              value: 11,
              key: 'zgaCnt',
              label: '总关爱次数',
              backgroundColor: '#725BE9',
            },
            {
              value: 0,
              key: 'planCnt',
              label: '心理测评次数',
              backgroundColor: '#FA9600',
            },
            {
              value: 0,
              key: 'pgCnt',
              label: '总评估次数',
              backgroundColor: '#13B999',
            },
            {
              value: 0,
              key: 'gyCnt',
              label: '总干预学生次数',
              backgroundColor: '#13B999',
            },
            {
              value: 0,
              key: 'bzrgtCnt',
              label: '班主任沟通次数',
              backgroundColor: '#13B999',
            },
            {
              value: 0,
              key: 'jxgtCnt',
              label: '家校沟通次数',
              backgroundColor: '#13B999',
            },
          ],
        },
      ],
      // stuOverviewList: [
      //   {
      //     title: '小叮当提醒学生概览',
      //     list: [
      //       {
      //         value: 126,
      //         label: '总提醒学生',
      //       },
      //       {
      //         value: 116,
      //         label: '已干预学生',
      //       },
      //       {
      //         value: 116,
      //         label: '已转好学生',
      //       },
      //     ],
      //   },
      //   {
      //     title: '重点关爱学生概览',
      //     list: [
      //       {
      //         value: 126,
      //         label: '总关爱学生',
      //       },
      //       {
      //         value: 116,
      //         label: '已评估学生数',
      //       },
      //       {
      //         value: 116,
      //         label: '已干预学生数',
      //       },
      //       {
      //         value: 126,
      //         label: '已家校沟通学生数',
      //       },
      //       {
      //         value: 116,
      //         label: '已转好学生数',
      //       },
      //     ],
      //   },
      // ],
    }
  },
  created() {
    this.getWordView()
  },
  methods: {
    changModeType() {
      this.$emit('changeModeType', this.modeType)
    },
    getWordView() {
      getAction('/home/psychologyTeacherWorkbench', this.queryParam).then((res) => {
        if (res.success) {
          const keys = Object.keys(res.result)
          if (!keys.length) return
          keys.forEach((key) => {
            const item = res.result[key]
            const index = this.stuCardList[0].list.findIndex((i) => {
              return i.key == key
            })
            if (index == -1) return
            this.$set(this.stuCardList[0].list[index], 'value', item)
            // console.log('数值数据：', this.stuCardList[0].list)
          })

          console.log('工作概况', res.result)
        }
      })
    },
    selectSchoolYear(record) {
      const year = record.text.split('年')[0]
      const timeRange = getYearStarting(year)
      this.$set(this.queryParam, 'beginDate', timeRange[0])
      this.$set(this.queryParam, 'endDate', timeRange[1])
      this.getWordView()
    },
  },
}
</script>
<style scoped lang="less">
.title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.row-box {
  padding: 10px !important;
  padding-bottom: 0 !important;
  border-radius: 10px;
  background-color: #fff;
}
.title-margin {
  margin-top: 10px;
  margin-bottom: 15px;
}
.card-content {
  display: flex;
  justify-content: space-between;
  .card-item {
    // flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    .item-value {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 2px;
    }
    .item-desc {
      font-size: 14px;
    }
  }
}
.key-point-item {
  height: 140px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
}
.plan-card {
  margin-bottom: 20px;
  /deep/ .ant-card-body {
    padding: 12px;
  }
  .plan-card-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.number-value {
  font-size: 30px;
  font-weight: bold;
  color: #fff;
  border-radius: 5px;
}
</style>
